// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
export type OptionVariantRows_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, totalCostInCents: number, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, wouldDeselect: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, option: { __typename?: 'ReadyPlanOption', id: string, name: string }, displayProducts: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export const OptionVariantRows_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment OptionVariantRows_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  group {
    id
    name
  }
  options {
    id
    totalPriceInCents
    totalCostInCents
    canBeSelected {
      allowed
      disabledReasons {
        message
      }
    }
    wouldDeselect {
      ...Named
    }
    option {
      ...Named
    }
    displayProducts {
      id
      displayName
      featuredImage {
        id
        asset {
          id
          previewUrl(resizing: {width: 192, region: SQUARE})
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;